import React, {useEffect, useState} from 'react'
import PropTypes from 'prop-types'
import i18n from 'i18next'
import actions from 'redux-auto'
import {shallowEqual, useSelector} from 'react-redux'
import ModalByProps from '#components/m/ModalByProps'
import Button from '#components/a/Button'
import {LoadingButton} from '#components/m/LoadingButton'
import ControlsGroup from '#components/m/ControlsGroup'
import Headline from '#components/a/Headline'
import Text from '#components/a/Text'
import UserMultiSelectionInput from '#components/m/Versetzungsplan/UserMultiSelectionInput'
import MonthRangePicker from '#components/m/MonthPicker/MonthRangePicker'
import {endOfMonth, startOfMonth} from 'ag-common/facades'

function PublishAbteilungenModal({azubis, disabled}) {
  const [showModal, setShowModal] = useState(false)
  const [selectedAzubiIds, setSelectedAzubiIds] = useState([])
  const [startDate, setStartDate] = useState(startOfMonth(new Date()))
  const [endDate, setEndDate] = useState(endOfMonth(new Date()))

  const isLoading = useSelector(state => state.versetzungsplan.isLoading, shallowEqual)

  const closeModal = () => {
    setShowModal(false)
    setSelectedAzubiIds([])
    setStartDate(startOfMonth(new Date()))
    setEndDate(endOfMonth(new Date()))
  }

  const onPublish = () => {
    const apiModel = {
      azubiIds: selectedAzubiIds,
      startDate,
      endDate,
    }
    actions.versetzungsplan.publishAbteilungen(apiModel)
    closeModal()
  }

  return (
    <div className="planung-freigeben">
      <Button
        event={() => setShowModal(true)}
        text={i18n.t('versetzungsplan_publish_button')}
        variant="primary"
        disabled={disabled}
      />
      <ModalByProps modalIsOpen={showModal} modifier="overflow">
        <div className="planung-freigeben-modal" data-testid="planung-freigeben-modal">
          <Headline modifier="article" importance={2} text={i18n.t('versetzungsplan_publish_modal_headline')} />
          <Text text={i18n.t('versetzungsplan_publish_modal_text')} />
          <span>{i18n.t('azubi_select_header')}</span>
          <UserMultiSelectionInput
            azubis={azubis}
            selectedValue={selectedAzubiIds}
            onSelectValue={setSelectedAzubiIds}
            selectAllText={i18n.t('versetzungsplan_publish_all_option')}
          />
          <MonthRangePicker
            startDate={startDate}
            endDate={endDate}
            setStartDate={setStartDate}
            setEndDate={setEndDate}
          />
          <ControlsGroup>
            <Button disabled={false} event={closeModal} text={i18n.t('misc_cancel')} variant="secondary" />
            <LoadingButton
              disabled={selectedAzubiIds.length === 0}
              isLoading={isLoading}
              event={onPublish}
              text={i18n.t('misc_publish')}
              loadingText={i18n.t('misc_publish_pending')}
              variant="primary"
            />
          </ControlsGroup>
        </div>
      </ModalByProps>
    </div>
  )
}

PublishAbteilungenModal.propTypes = {
  azubis: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      firstname: PropTypes.string,
      lastname: PropTypes.string,
    }),
  ).isRequired,
  disabled: PropTypes.bool,
}

export default PublishAbteilungenModal
